import { useEffect } from "react";

const DEFAULT_TITLE = "Cursos de Formación Sociosanitaria Online | LaClaseEnCasa";

/** Sets document.title while the component is mounted, restoring the
 * default title (the public home page's) on unmount. */
export default function useDocumentTitle(title) {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} | LaClaseEnCasa` : DEFAULT_TITLE;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
